import {CSSProperties, FC} from 'react';


export interface IIconEngineBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconEngineBmw: FC<IIconEngineBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="m21.735 12.061-2.244-1.704a.668.668 0 0 0-1.075.534v1.043h-.664V10.88c0-.37-.3-.67-.67-.67h-1.334V7.72c0-.37-.3-.67-.67-.67h-2.084v-.71h.56a.67.67 0 0 0 0-1.341H9.227a.67.67 0 0 0 0 1.34h.562v.711h-2.59c-.37 0-.67.3-.67.67V9.03h-1.31c-.37 0-.67.3-.67.67v1.533H3.34V9.331a.67.67 0 0 0-1.34 0v7.008a.67.67 0 1 0 1.34 0v-1.9H4.55v1.57c0 .37.3.67.67.67h1.685l2.364 2.912a.67.67 0 0 0 .52.247h7.294c.37 0 .67-.3.67-.67v-.885h.664v.885a.67.67 0 0 0 1.106.509l2.244-1.924a.67.67 0 0 0 .234-.509v-4.65a.67.67 0 0 0-.265-.533Z" />
        </svg>
    );
};
